import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

// Reusable "Get Your Free Business Growth Score" CTA used across content pages.
export const GrowthCTA = ({ industry = "", label = "Get Your Free Business Growth Score", testid = "growth-cta" }) => {
  const to = industry ? `/ai-business-growth?industry=${encodeURIComponent(industry)}` : "/ai-business-growth";
  return (
    <Link to={to} data-testid={testid}
      className="group my-10 flex flex-col sm:flex-row sm:items-center gap-4 justify-between rounded-3xl bg-primary text-primary-foreground p-6 md:p-7 grid-bg overflow-hidden hover:brightness-105 transition-[filter]">
      <div>
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-foreground/15 px-3 py-1 text-xs font-bold uppercase tracking-wide">
          <Sparkles className="h-3.5 w-3.5" /> Free AI Growth Report
        </span>
        <p className="font-head text-xl md:text-2xl font-black mt-3 leading-tight max-w-xl">{label}</p>
        <p className="opacity-90 text-sm mt-1">See your growth score, find missed opportunities, and get a plan to win more customers — in 30 seconds.</p>
      </div>
      <span className="inline-flex items-center gap-2 rounded-full bg-primary-foreground text-primary px-6 h-12 font-bold shrink-0 group-hover:translate-x-1 transition-transform">
        Get my score <ArrowRight className="h-4 w-4" />
      </span>
    </Link>
  );
};
